<p-table [value]="courseStartDates">
  <ng-template pTemplate="header">
    <tr [class]="'table__header--' + ALP?.toLocaleLowerCase()">
      <th class="table__header--uppercase">
        {{ columnLabels.title }}
      </th>
      <th>{{ columnLabels.startDates }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr>
      <td>{{ data.course }}</td>
      <td>{{ data.startDates ?? '-' }}</td>
    </tr>
  </ng-template>
</p-table>
